import React, { FC, useCallback } from 'react'
import { Button } from 'transfix-ui/components/Button'
import { useGlobalToast } from 'transfix-ui/components/Toast'
import Box from 'transfix-ui/core/Box'
import { useModalState } from 'utils/hooks/useModalState'
import { RearrangeShipmentStopsModal } from '../RearrangeShipmentStops'

export const RearrangeShipmentStopsModalButton: FC = () => {
  const { openToast } = useGlobalToast()
  const { createToggleHandler, modalState } = useModalState({
    rearrangeModal: false,
  })

  const openHandler = createToggleHandler('rearrangeModal', true)
  const closeModal = createToggleHandler('rearrangeModal', false)
  const closeHandler = useCallback(
    (toastMessage?: string) => {
      if (toastMessage) {
        openToast({
          toastMessage,
          toastType: 'default',
        })
      }

      closeModal()
    },
    [closeModal, openToast]
  )

  return (
    <Box mr={1}>
      <RearrangeShipmentStopsModal open={modalState.rearrangeModal} onClose={closeHandler} />
      <Button color='tertiary' onClick={openHandler}>
        Rearrange/Remove Stops
      </Button>
    </Box>
  )
}
